import {
  activateExperiment,
  isExperimentEnabled,
  trackEvent
} from 'views/assets/scripts/optimizely'

import { PRE_QUERY_SUGGEST_NAME } from 'shared/experiments/consts'

import {
  SELECTOR_DUMMY_SEARCH_BOX,
  SELECTOR_MOBILE_SEARCH_ICON
} from 'views/containers/browser/SearchBoxContainer/consts'

const OPTIMIZELY_EVENT_CLICK_ON_SUGGESTION = 'PQSL - Click on suggestion'
const OPTIMIZELY_EVENT_CLICK_ON_QUERY_PRODUCT = 'PQSL - Click on query product'
const OPTIMIZELY_EVENT_CLICK_ON_PRODUCT = 'PQSL - Click on suggested product'
const OPTIMIZELY_EVENT_CLICK_ON_CATEGORY = 'PQSL - Click on category'

export default () => {
  if (!isExperimentEnabled(PRE_QUERY_SUGGEST_NAME)) {
    return
  }

  const searchInputs = [
    document.querySelector(SELECTOR_MOBILE_SEARCH_ICON),
    document.querySelector(SELECTOR_DUMMY_SEARCH_BOX)
  ].filter(Boolean)

  const activate = () => {
    activateExperiment(PRE_QUERY_SUGGEST_NAME)

    searchInputs.forEach(input => {
      input.removeEventListener('click', activate)
    })
  }

  searchInputs.forEach(input => {
    input.addEventListener('click', activate)
  })

  const experimentContainer = document.getElementById('h-SearchBox__mobile')

  experimentContainer.addEventListener('click', event => {
    const { target } = event

    if (target.closest('[data-clientside-hook~="SearchBoxListItemLink"]')) {
      trackEvent(OPTIMIZELY_EVENT_CLICK_ON_QUERY_PRODUCT)
    }

    if (target.closest('[data-clientside-hook~="SearchBoxListSuggestLink"]')) {
      trackEvent(OPTIMIZELY_EVENT_CLICK_ON_SUGGESTION)
    }

    if (target.closest('[data-clientside-hook~="SearchBoxListItemLink_PQ"]')) {
      trackEvent(OPTIMIZELY_EVENT_CLICK_ON_PRODUCT)
    }

    if (target.closest('[data-clientside-hook~="SearhcBoxCategoryLink"]')) {
      trackEvent(OPTIMIZELY_EVENT_CLICK_ON_CATEGORY)
    }
  })
}
